export const normalizeLocalityToCityId = locality =>
  locality
    ? locality
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s/g, '_')
    : '';
